import React from "react"
import { Row } from "./UI"

interface TopBarProps {
  left?: React.ReactNode
  center?: React.ReactNode
  right?: React.ReactNode
}

export function TopBar({ left, center, right }: TopBarProps) {
  return (
    <Row
      borderBottom="1px solid"
      borderColor="#eee"
      justifyContent="space-between"
      height={60}
      px={16}
    >
      <div>{left}</div>
      <div>{center}</div>
      <div>{right}</div>
    </Row>
  )
}
